/* WALLTRAUD Produkt teilen – nur nach Nutzerklick, ohne externe Bibliothek. */
(() => {
  if (window.__wtShareReady) return;
  window.__wtShareReady = true;

  const shareData = (root) => {
    const cleanBase = root.dataset.productUrl;
    const sectionId = root.dataset.productSection;
    const holder = root.closest('product-info');
    const form = holder && holder.querySelector(`#product-form-${CSS.escape(sectionId)}`);
    const variantId = form && form.querySelector('input[name="id"]')?.value;
    const url = new URL(cleanBase, window.location.origin);
    // Keine srsltid-/utm-Parameter von der aktuell geöffneten Seite übernehmen.
    if (root.dataset.hasVariants === 'true' && /^\d+$/.test(variantId || '')) {
      url.searchParams.set('variant', variantId);
    }
    return { url: url.toString(), title: root.dataset.productTitle || '' };
  };

  const fallbackCopy = (value) => {
    const field = document.createElement('textarea');
    field.value = value;
    field.setAttribute('readonly', '');
    field.style.cssText = 'position:absolute;left:-9999px;top:0;';
    document.body.appendChild(field);
    field.select();
    const ok = document.execCommand('copy');
    field.remove();
    return ok;
  };

  document.addEventListener('click', async (event) => {
    const target = event.target.closest('.wt-share__button');
    if (!target) return;
    const root = target.closest('.wt-share');
    if (!root) return;
    const { url, title } = shareData(root);

    if (target.matches('.wt-share__button--wa')) {
      const message = `Schau mal, das habe ich bei WALLTRAUD® entdeckt! 👀\n\n${title}\n${url}`;
      target.href = `https://wa.me/?text=${encodeURIComponent(message)}`;
      return; // Native Link-Navigation (auch für Tastatur und Mobilgeräte).
    }

    if (!target.matches('.wt-share__button--copy')) return;
    const status = root.querySelector('.wt-share__status');
    try {
      if (navigator.clipboard?.writeText) {
        await navigator.clipboard.writeText(url);
      } else if (!fallbackCopy(url)) {
        throw new Error('Clipboard unsupported');
      }
      status.textContent = 'Produktlink kopiert!';
    } catch (error) {
      // Bei deaktivierter Zwischenablage keine falsche Erfolgsmeldung anzeigen.
      status.textContent = 'Link konnte nicht kopiert werden. Bitte Browserfreigabe prüfen.';
    }
    clearTimeout(root._wtShareTimer);
    root._wtShareTimer = setTimeout(() => { status.textContent = ''; }, 3500);
  });
})();
